import { color, fontFamily, fontSize } from "@xingternal/360-styles/helpers"
import merge from "deepmerge"
import { combineMerge } from "@/helpers/combineMerge"
import { customTooltip } from "./helpers"

export default (options = {}) => {
  const initial = {
    maintainAspectRatio: false,
    animation: {
      duration: 250,
    },
    legend: {
      display: false,
    },
    hover: {
      intersect: false,
    },
    tooltips: {
      enabled: false,
      custom: customTooltip,
      mode: "index",
      intersect: false,
      displayColors: false,
      backgroundColor: color("gray-80"),
      bodyFontColor: "white",
      bodyFontFamily: fontFamily("Xing Sans"),
      bodyFontSize: fontSize("fz11"),
      caretSize: 0,
      cornerRadius: 4,
      titleFontFamily: fontFamily("Xing Sans"),
      titleFontSize: fontSize("fz11"),
      callbacks: {
        title: (tooltipItems, { labels }) => labels[tooltipItems[0].index],
        label: (tooltipItems, data) => {
          const { datasetIndex, index } = tooltipItems
          const set = data.datasets[datasetIndex]
          const value = set.data[index]

          return `${value} ${set.label}`
        },
      },
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            lineWidth: 0,
            zeroLineWidth: 1,
            zeroLineColor: color("gray-10"),
          },
          ticks: {
            fontFamily: fontFamily("Xing Sans"),
            fontColor: color("gray-50"),
            fontSize: fontSize("fz11"),
            beginAtZero: true,
            padding: 5,
            userCallback: (label) =>
              Math.floor(label) === label ? label : null,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            offsetGridLines: true,
            display: false,
            zeroLineColor: color("gray-20"),
          },
          ticks: {
            autoSkipPadding: 10,
            fontFamily: fontFamily("Xing Sans"),
            fontColor: color("gray-50"),
            fontSize: fontSize("fz11"),
            maxRotation: 0,
            callback(value, index, values) {
              const labelValues = value.split(" ")
              const day = labelValues[0]
              const month = labelValues[1]

              return `${day} ${month}`
            },
          },
          time: {
            tooltipFormat: "DD MMM YYYY",
            minUnit: "day",
          },
        },
      ],
    },
  }

  return merge(initial, options, { arrayMerge: combineMerge })
}
